<template>
    <div class="contextMenu" :style="{top:data.y+'px', left:data.x+'px'}" @focusout="focusout">
        <template v-for="(item,key) in data.items">
            <a v-if="item.link" class="contextMenu-item" :key="key" :href="item.link" @click.native="close()"
                         :tabindex="key">
                <span :class="item.icon" class="icon" :style="{'color':item.color||'var(--main)'}"/>
                {{ item.name }}
            </a>
            <div v-else class="contextMenu-item" :key="key" @click="item.command();close()" :tabindex="key">
                <span :class="item.icon" class="icon" :style="{'color':item.color||'var(--main)'}"/>
                {{ item.name }}
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "ContextMenu",
    props: ['data'],
    mounted() {
        this.$el.firstElementChild?.focus();
    },
    methods: {
        focusout() {
            setTimeout(() => {
                const focus = document.querySelector(':focus');
                if (!this.$el.querySelector(':focus')) {
                    this.close();
                }
            }, 1);
        },
        close() {
            this.$store.commit('setContextMenu', null);
        }
    }
}
</script>

<style scoped>

</style>
